import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { AuthState } from '../hooks/useAuthStateModel';
import { authHelpSteps } from '../hooks/authHelpSteps';

interface AuthHelpWizardProps {
  open: boolean;
  onClose: () => void;
  /** The currently detected auth state; drives which walkthrough is shown. */
  state: AuthState | null;
}

/**
 * A thin, state-aware "explain it like I'm 5" help dialog. All content comes
 * from the pure authHelpSteps() function — this component only renders it.
 */
export default function AuthHelpWizard({
  open,
  onClose,
  state,
}: AuthHelpWizardProps) {
  const { title, steps } = authHelpSteps(state);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <List sx={{ listStyleType: 'decimal', pl: 3 }}>
          {steps.map((step, i) => (
            <ListItem key={i} sx={{ display: 'list-item', px: 0, py: 0.5 }}>
              <ListItemText primary={step} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
